import type { StaffRole } from '@ucp/web/lib';

/**
 * Every role that holds an `hr_assistant_ask` or `hr_knowledge_manage` capability
 * (capabilities.ts). Mirrors the server role→capability map; `L6_PLATFORM_ADMIN` is
 * DELIBERATELY absent (ADR-018 EoP — never an HR shortcut). PRO-1650 Knowledge-route
 * L6 access is route-level (`HrAssistantRouteGuard` + Knowledge task `anyOf`), not
 * this list. Extracted into this
 * dependency-light module so the `AppRoutes` route guard can import it without pulling
 * the lazy-loaded `HrPeopleAssistantSurface` into the initial bundle (mirrors
 * `atrRoles.ts`).
 */
export const HR_PEOPLE_ASSISTANT_ROLES: readonly StaffRole[] = [
  'HR_ASSISTANT_USER',
  'HR_KNOWLEDGE_STEWARD',
];
